import { PrincipleMap } from "./principles";

export interface Room extends PrincipleMap {
  id: string;
  label: string;
  preface: string; // What it's called before opening

  shrouded?: boolean; // Not unlocked
  sealed?: boolean; // Hidden
  hasPreviouslyUnshrouded?: boolean; // Has it been unlocked. idk maybe it can reshroud?
}

export function GetRoomById(id: string): Room {
  id = "terrain." + id;
  const room = Rooms.find((t) => t.id == id);
  if (!room) throw new Error(`Couldn't find room ${id}`);
  return room;
}

export const Rooms: Room[] = [
  {
    id: "terrain.atrium",
    preface: "Shadowed Atrium",
    label: "Atrium",
    knock: 5,
    lantern: 5,
  },
  {
    id: "terrain.backstairs",
    preface: "Blockaded Stairs",
    label: "Back Stairs",
    heart: 9,
    knock: 9,
    lantern: 9,
    moon: 9,
    rose: 9,
    scale: 9,
  },
  {
    id: "terrain.ballroomduellinghall",
    preface: "Dim Hall",
    label: "Duelling Hall",
    edge: 8,
    grail: 8,
  },
  {
    id: "terrain.bells",
    preface: "Fallen Bells",
    label: "Bells",
    forge: 11,
    heart: 11,
    sky: 11,
  },
  {
    id: "terrain.boathouse",
    preface: "Perilous Path",
    label: "Boathouse",
    moon: 13,
    rose: 13,
  },
  {
    id: "terrain.brancrug",
    preface: "Brancrug Village",
    label: "Brancrug Village",
    achievements: ["A_EXPLORE_VILLAGE"],
  },
  {
    id: "terrain.brancrugbeach",
    preface: "",
    label: "St Brandan’s Cove",
  },
  {
    id: "terrain.catacombs",
    preface: "Rattling Tunnels",
    label: "Catacombs",
    grail: 15,
    winter: 15,
  },
  {
    id: "terrain.cell-adept",
    preface: "Sealed Cell",
    label: "Cell: Adepts",
    forge: 12,
    knock: 12,
  },
  {
    id: "terrain.cell-long",
    preface: "Trapped Cell",
    label: "Cell: Long",
    edge: 13,
    knock: 13,
  },
  {
    id: "terrain.cell-unknown",
    preface: "Mazed Cell",
    label: "Cell: ?",
    grail: 14,
    moth: 14,
    scale: 14,
  },
  {
    id: "terrain.cell-worm-inhabited",
    preface: "Impermeable Cell",
    label: "Cell: Worm-Inhabited",
    forge: 15,
    knock: 15,
    sky: 15,
  },
  {
    id: "terrain.chancel",
    preface: "Veiled Chamber",
    label: "Chancel of the Abbey Church",
    heart: 9,
    lantern: 9,
    moon: 9,
    winter: 9,
  },
  {
    id: "terrain.chapelascite",
    preface: "A Wintry Forbidding",
    label: "Chapel Ascite",
    edge: 14,
    knock: 14,
  },
  {
    id: "terrain.chapelcalicite",
    preface: "A Red Forbidding",
    label: "Chapel Calicite",
    grail: 14,
    nectar: 14,
  },
  {
    id: "terrain.chapelmalachite",
    preface: "A Honeyed Forbidding",
    label: "Chapel Malachite",
    heart: 14,
    nectar: 14,
  },
  {
    id: "terrain.chapterhouse",
    preface: "Echoing Chamber",
    label: "Chapter House",
    lantern: 9,
    moon: 9,
    winter: 9,
  },
  {
    id: "terrain.churchtower1",
    preface: "Ill-Omened Tower",
    label: "Church Tower",
    forge: 9,
    lantern: 9,
    sky: 9,
  },
  {
    id: "terrain.churchtower2",
    preface: "Stopped Clock",
    label: "Tower Clock",
    forge: 10,
    sky: 10,
    winter: 10,
  },
  {
    id: "terrain.cloister",
    preface: "Cloistered Garden",
    label: "St Brandan’s Cloister",
    lantern: 2,
    nectar: 2,
  },
  {
    id: "terrain.columbiccrypt",
    preface: "Fluttering Crypt",
    label: "Columbic Crypt",
    moon: 15,
    winter: 15,
  },
  {
    id: "terrain.crucibletower1",
    preface: "Smoky Chamber",
    label: "Crucible Tower: Governor's Office",
    forge: 12,
    heart: 12,
  },
  {
    id: "terrain.crucibletower2",
    preface: "Stifling Chamber",
    label: "Crucible Tower: Governor's Quarters",
    forge: 13,
    winter: 13,
  },
  {
    id: "terrain.crucibletower3",
    preface: "Charred Chamber",
    label: "Crucible Tower: Interview Laboratory",
    achievements: ["A_EVENT_FIREFIGHTER"],
    knock: 14,
    moth: 14,
    winter: 14,
  },
  {
    id: "terrain.cucurbitbridge",
    preface: "Mist-Cloaked Bridge",
    label: "Cucurbit Bridge",
    forge: 1,
    lantern: 1,
    sky: 1,
  },
  {
    id: "terrain.deeplightcaves",
    preface: "Menacing Phosphorescence",
    label: "Deeplight Caves",
    moon: 14,
    nectar: 14,
  },
  {
    id: "terrain.deepwelldescent",
    preface: "Root-Thronged Descent",
    label: "Deep Well Descent",
    heart: 9,
    nectar: 9,
    scale: 9,
  },
  {
    id: "terrain.earlbrian'sfield",
    preface: "Mist-Sunk Meadow",
    label: "Earl Brian's Field",
    nectar: 11,
    rose: 11,
    sky: 11,
  },
  {
    id: "terrain.earthcellar",
    preface: "Collapsed Cellar",
    label: "Earth Cellar",
    heart: 11,
    nectar: 11,
    scale: 11,
  },
  {
    id: "terrain.entrancehall",
    preface: "The First True Threshold",
    label: "Entrance Hall",
    knock: 3,
    rose: 3,
  },
  {
    id: "terrain.fluddgallery",
    preface: "Despoiled Laboratory",
    label: "Fludd Gallery",
    forge: 6,
    winter: 6,
  },
  {
    id: "terrain.foundry",
    preface: "Ravaged Foundry",
    label: "Foundry",
    forge: 6,
    scale: 6,
  },
  {
    id: "terrain.gaolbridge",
    preface: "Broken Bridge",
    label: "Lesser Bridge",
    edge: 9,
    forge: 9,
    knock: 9,
  },
  {
    id: "terrain.gaolcellar",
    preface: "Ravaged Cellar",
    label: "Gaol Cellar",
    forge: 13,
    scale: 13,
    winter: 13,
  },
  {
    id: "terrain.gaolhall",
    preface: "Worm-Eaten Hall",
    label: "Gaol Hall",
    forge: 11,
    moth: 11,
    winter: 11,
  },
  {
    id: "terrain.gaolkitchen",
    preface: "Worm-Gnawed Kitchen",
    label: "Gaol Kitchen",
    grail: 12,
    heart: 12,
    winter: 12,
  },
  {
    id: "terrain.gaolyard",
    preface: "Blackened Yard",
    label: "Gaol Yard",
    grail: 10,
    heart: 10,
    winter: 10,
  },
  {
    id: "terrain.gatehouse",
    preface: "The great gate of the House",
    label: "Watchman's Tower: Gatehouse",
    knock: 2,
  },
  {
    id: "terrain.gloriousstair",
    preface: "Gloomy Stair",
    label: "Glorious Stair",
    edge: 6,
    forge: 6,
    winter: 6,
  },
  {
    id: "terrain.grandascent.1",
    preface: "Grand Ascent - First Floor",
    label: "Grand Ascent - First Floor",
    forge: 4,
    heart: 4,
    sky: 4,
    winter: 4,
  },
  {
    id: "terrain.grandascent.2",
    preface: "Grand Ascent - Second Floor",
    label: "Grand Ascent -Second Floor",
    grail: 4,
    knock: 5,
    nectar: 5,
    winter: 5,
  },
  {
    id: "terrain.grandascent.3",
    preface: "Grand Ascent - Third Floor",
    label: "Grand Ascent -Third Floor",
    edge: 5,
    forge: 4,
    knock: 5,
    winter: 5,
  },
  {
    id: "terrain.grandascent.g",
    preface: "Grand Ascent - Ground Floor",
    label: "Grand Ascent - Ground Floor",
    edge: 4,
    heart: 4,
    moon: 4,
    winter: 4,
  },
  {
    id: "terrain.gullcolony",
    preface: "Shrieking Gull-Cloud",
    label: "Gull Colony",
    edge: 12,
    sky: 12,
  },
  {
    id: "terrain.gullscryloggia",
    preface: "Squawkful Loggia",
    label: "Gullscry Loggia",
    achievements: ["A_EXPLORE_BARONIAL"],
    rose: 9,
    sky: 9,
  },
  {
    id: "terrain.gullscrytower1",
    preface: "Weeping Chamber",
    label: "Gullscry Tower: Valentine's Room",
    forge: 10,
    heart: 10,
    sky: 10,
  },
  {
    id: "terrain.gullscrytower2",
    preface: "Howling Chamber",
    label: "Gullscry Tower: Eales' Room",
    knock: 11,
    sky: 11,
    winter: 11,
  },
  {
    id: "terrain.gullscrytower3",
    preface: "Screaming Summit",
    label: "Gullscry Tower: Summit",
    rose: 12,
    sky: 12,
    winter: 12,
  },
  {
    id: "terrain.hallofmirrors",
    preface: "Silvered Snares",
    label: "Hall of Division",
    edge: 8,
    winter: 8,
  },
  {
    id: "terrain.hallofvoices",
    preface: "Silent Hall",
    label: "Hall of Voices",
    moth: 15,
    rose: 15,
  },
  {
    id: "terrain.hermitcell",
    preface: "Gaping Darkness",
    label: "Hermit Cell",
    heart: 12,
    moth: 12,
  },
  {
    id: "terrain.hiddenstair",
    preface: "Rustling Stair",
    label: "Hidden Stair",
    moon: 11,
    scale: 11,
  },
  {
    id: "terrain.infirmary1a",
    preface: "Gloomy Room",
    label: "Examination Room",
    edge: 5,
    heart: 5,
  },
  {
    id: "terrain.infirmary1b",
    preface: "Neglected Room",
    label: "Patients' Lounge",
    grail: 5,
    heart: 5,
  },
  {
    id: "terrain.infirmaryg",
    preface: "Infirmary",
    label: "Infirmary",
    heart: 4,
    rose: 4,
  },
  {
    id: "terrain.ironvault",
    preface: "Sealed Vault",
    label: "Iron Vault",
    edge: 16,
    knock: 16,
  },
  {
    id: "terrain.ivoryvault",
    preface: "Sealed Vault",
    label: "Ivory Vault",
    knock: 14,
    scale: 14,
  },
  {
    id: "terrain.kitchen",
    preface: "Ruined Kitchen",
    label: "Kitchen",
    forge: 6,
    sky: 6,
  },
  {
    id: "terrain.kitchengarden",
    preface: "Overgrown Kitchen Garden",
    label: "Kitchen Garden",
    grail: 9,
    nectar: 9,
  },
  {
    id: "terrain.librarianquarters",
    preface: "Abandoned Librarian's Quarters",
    label: "Librarian's Quarters",
    achievements: ["A_EXPLORE_CURIA"],
    forge: 3,
    heart: 3,
    lantern: 3,
    scale: 3,
  },
  {
    id: "terrain.loadingdock",
    preface: "Sagging Dock",
    label: "Loading Dock",
    moon: 14,
    rose: 14,
  },
  {
    id: "terrain.lodge",
    preface: "Lodge at the Gate",
    label: "Keeper's Lodge",
    forge: 2,
    heart: 1,
    knock: 1,
  },
  {
    id: "terrain.longtower1",
    preface: "Long Tower: First Floor",
    label: "Long Tower: Solomon's Study",
    lantern: 3,
    winter: 3,
  },
  {
    id: "terrain.longtower2",
    preface: "Long Tower: Second Floor",
    label: "Long Tower: Solomon's Quarters",
    lantern: 4,
    winter: 4,
  },
  {
    id: "terrain.lowerpumproom",
    preface: "Flooded Level",
    label: "Lower Pump Room",
    forge: 3,
    knock: 3,
  },
  {
    id: "terrain.mapchamber",
    preface: "Web-Snared Room",
    label: "Map Room",
    heart: 6,
    rose: 6,
    sky: 6,
  },
  {
    id: "terrain.mazarineroom",
    preface: "Reeking Chamber",
    label: "Mazarine Room",
    heart: 6,
    sky: 6,
  },
  {
    id: "terrain.motleytower1",
    preface: "Motley Tower: First Floor",
    label: "Motley Tower: Illopoly's Nook",
    heart: 5,
    moth: 5,
  },
  {
    id: "terrain.motleytower2",
    preface: "Motley Tower: Second Floor",
    label: "Motley Tower: Dispensary",
    heart: 6,
    moth: 6,
  },
  {
    id: "terrain.motleytower3",
    preface: "Motley Tower: Third Floor",
    label: "Motley Tower: Regensburg Room",
    heart: 6,
    sky: 6,
  },
  {
    id: "terrain.narthex",
    preface: "Slithering Fountain",
    label: "Narthex",
    edge: 14,
    knock: 14,
    scale: 14,
  },
  {
    id: "terrain.nave",
    preface: "Darkened Church",
    label: "Nave of the Abbey Church",
    heart: 6,
    lantern: 6,
  },
  {
    id: "terrain.nightgallery",
    preface: "Shrouded Space",
    label: "Night Gallery",
    moon: 10,
    winter: 10,
  },
  {
    id: "terrain.ocean",
    preface: "",
    label: "The Atlantic Ocean",
  },
  {
    id: "terrain.oubliette",
    preface: "Incandescent Hollow",
    label: "Oubliette",
    achievements: ["A_EXPLORE_GAOL"],
    forge: 15,
    knock: 15,
    winter: 15,
  },
  {
    id: "terrain.ourladybeneath",
    preface: "Abandoned Church",
    label: "Our Lady Beneath",
    knock: 4,
    moth: 4,
    nectar: 4,
    winter: 4,
  },
  {
    id: "terrain.palechamber",
    preface: "Icy Bedroom",
    label: "Pale Chamber",
    moth: 7,
    winter: 7,
  },
  {
    id: "terrain.pantry",
    preface: "Wrecked Pantry",
    label: "Pantry",
    heart: 7,
    nectar: 7,
  },
  {
    id: "terrain.physicgarden",
    preface: "Weed-Choked Garden",
    label: "Physic Garden",
    heart: 3,
    nectar: 3,
  },
  {
    id: "terrain.practicgarden",
    preface: "Walled Garden",
    label: "Practic Garden",
    edge: 4,
    nectar: 4,
  },
  {
    id: "terrain.radiantstair",
    preface: "Shrouded Stair",
    label: "Radiant Stair",
    edge: 6,
    forge: 6,
    knock: 6,
    lantern: 6,
  },
  {
    id: "terrain.readingroom",
    preface: "Dimly Lit Chamber",
    label: "Reading Room",
    lantern: 5,
    rose: 5,
  },
  {
    id: "terrain.refectory",
    preface: "Rose-Haunted Hall",
    label: "Refectory",
    grail: 7,
    nectar: 7,
  },
  {
    id: "terrain.rowenarium",
    preface: "Crystallised Chamber",
    label: "Rowenarium",
    rose: 13,
    winter: 13,
  },
  {
    id: "terrain.sacredspring",
    preface: "Wheel-Filled Spring",
    label: "Sacred Spring",
    moon: 10,
    nectar: 10,
  },
  {
    id: "terrain.scentgarden",
    preface: "Tangle of Thorns",
    label: "Scent Garden",
    grail: 4,
    nectar: 4,
  },
  {
    id: "terrain.seacaves",
    preface: "Submerged Sea-Caves",
    label: "Sea-Caves",
    moon: 3,
    scale: 3,
  },
  {
    id: "terrain.secondbeach",
    preface: "Tidal Flats",
    label: "Crowcross Sands",
    moon: 2,
    winter: 2,
  },
  {
    id: "terrain.servantshall",
    preface: "Ruinous Hall",
    label: "Servants' Hall",
    heart: 5,
    scale: 5,
  },
  {
    id: "terrain.servantsquarters1",
    preface: "Maze-Crazed Room",
    label: "Servants' Quarters - South",
    heart: 8,
    rose: 8,
  },
  {
    id: "terrain.servantsquarters2",
    preface: "Wounded Room",
    label: "Servants' Quarters - North",
    heart: 8,
    knock: 8,
  },
  {
    id: "terrain.severnchamber",
    preface: "Abandoned Bedroom",
    label: "Severn Chamber",
    moon: 5,
    rose: 5,
  },
  {
    id: "terrain.shrinetosttentreto",
    preface: "Pulsing Darkness",
    label: "Shrine to St Tentreto",
    achievements: ["A_EXPLORE_UNDERGROUND"],
    moth: 15,
    scale: 15,
  },
  {
    id: "terrain.silvervault",
    preface: "Sealed Vault",
    label: "Silver Vault",
    grail: 14,
    knock: 14,
  },
  {
    id: "terrain.smuggler'sden",
    preface: "Wing-Haunted Cave",
    label: "Smuggler's Den",
    forge: 12,
    grail: 12,
  },
  {
    id: "terrain.solarium",
    preface: "Glaring Room",
    label: "Solarium",
    heart: 10,
    lantern: 10,
    winter: 10,
  },
  {
    id: "terrain.spire",
    preface: "Wyrd-Cursed Spire",
    label: "Spire",
    achievements: ["A_EXPLORE_CHURCH"],
    lantern: 12,
    moth: 12,
    sky: 12,
  },
  {
    id: "terrain.staff-room",
    preface: "Blackened Staff-Room",
    label: "Staff-Room",
    grail: 11,
    heart: 11,
  },
  {
    id: "terrain.stairtenebrous",
    preface: "Shadowed Stair",
    label: "Stair Tenebrous",
    edge: 3,
    heart: 3,
    lantern: 3,
    moon: 3,
    rose: 3,
    sky: 3,
    winter: 3,
  },
  {
    id: "terrain.stores",
    preface: "Heart-Haunted Room",
    label: "Stores",
    grail: 8,
    heart: 8,
    moon: 8,
  },
  {
    id: "terrain.upperpumproom",
    preface: "Room of Rusts",
    label: "Upper Pump Room",
    forge: 11,
    scale: 11,
  },
  {
    id: "terrain.vestibulumtransitus",
    preface: "Rattling Bridge",
    label: "Vestibulum Transitus",
    edge: 2,
    heart: 2,
    knock: 2,
    lantern: 2,
    moon: 2,
    scale: 2,
    winter: 2,
  },
  {
    id: "terrain.violetchamber",
    preface: "Serpent-Haunted Bedroom",
    label: "Violet Chamber",
    knock: 6,
    scale: 6,
  },
  {
    id: "terrain.watchmanstower1",
    preface: "Gatehouse Stairs",
    label: "Watchman's Tower: First Floor",
    forge: 2,
    lantern: 2,
  },
  {
    id: "terrain.watchmanstower2",
    preface: "Watchman's Tower: Top Floor",
    label: "Watchman's Tower: Observatory",
    grail: 2,
    sky: 2,
  },
  {
    id: "terrain.well",
    preface: "Deserted Well",
    label: "Well",
    moon: 7,
    nectar: 7,
  },
  {
    id: "terrain.welldescent",
    preface: "Creeper-Crowded Descent",
    label: "Well Descent",
    moon: 8,
    nectar: 8,
    scale: 8,
  },
  {
    id: "terrain.westcottroom",
    preface: "Smoking-Room",
    label: "Westcott Room",
    forge: 5,
    lantern: 5,
  },
  {
    id: "terrain.whisperingstair",
    preface: "Riddling Stair",
    label: "Whispering Stair",
    moon: 12,
    rose: 12,
  },
  {
    id: "terrain.windlitgallery",
    preface: "Wind-Prowled Gallery",
    label: "Windlit Gallery",
    forge: 8,
    lantern: 8,
    sky: 8,
  },
  {
    id: "terrain.winecellar",
    preface: "Infested Wine-Cellar",
    label: "Wine Cellar",
    grail: 10,
    moth: 10,
  },
] as Room[];
